import { http } from "./client";
import type { LeaveBalance } from "@/types/domain";

export interface LeaveBalanceAdjustInput {
  employee_id: string;
  leave_type_id: string;
  year?: number;
  delta: number;
  reason: string;
}

// GET /leave-balances returns a plain array, not a paginated envelope - one
// row per leave type for the given employee/year - so this uses http.get,
// not http.getPage, unlike every other list in this module.
export const leaveBalancesApi = {
  list: (employeeId?: string, year?: number) =>
    http.get<LeaveBalance[]>("/leave-balances", { employee_id: employeeId, year }),
  // Employee Self Service alias - always self-scoped, no query params.
  listSelf: () => http.get<LeaveBalance[]>("/employee/self/leave-balances"),
  // HR/Admin manual correction - requires leave.policy.manage, enforced both
  // at the route and again inside LeaveBalanceService.Adjust.
  adjust: (input: LeaveBalanceAdjustInput) => http.post<LeaveBalance>("/leave-balances/adjust", input),
};
